import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import "./modal.scss";
import OutlinedPinkButton from "../buttons/outlinedPinkButton/OutlinedPinkButton";
import GradientButton from "../buttons/gradientButton/GradientButton";

Modal.setAppElement("#root");

const ModalComponent = ({
  isOpen,
  onClose,
  onValidate,
  title,
  message,
  actionsComponent,
  hideCloseButton,
  shouldNotCloseOnOverlayClick,
  modalClassName,
  overlayClassName,
  validateLabel,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={`customModal ${modalClassName || ""}`.trim()}
      overlayClassName={`modalOverlay ${overlayClassName || ""}`.trim()}
      shouldCloseOnOverlayClick={!shouldNotCloseOnOverlayClick}
    >
      <h2 className="modalTitle">{title}</h2>
      <hr />
      {message ? <p className="modalMessage">{message}</p> : null}
      <div className="modal-actions">
        {actionsComponent}

        <div className="modalButtons">
          {!hideCloseButton && (
            <OutlinedPinkButton onPressFunction={onClose}>{t("close")}</OutlinedPinkButton>
          )}
          {!!onValidate && (
            <GradientButton onPress={onValidate}>{validateLabel || t("validate")}</GradientButton>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalComponent;
